import { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { useSellerNotifications } from "@/hooks/useSellerNotifications";
import { useToast } from "@/components/feature/Toast";

/**
 * Listener global de alertas para administradores. Montado en el layout, se
 * queda escuchando si llegan solicitudes de vendedor nuevas y lanza una
 * notificación con un botón que lleva directo a la revisión de vendedores.
 */
export default function AdminNotifications() {
  const { pendingCount, newApplicant, dismiss } = useSellerNotifications();
  const { showToast } = useToast();
  const navigate = useNavigate();

  useEffect(() => {
    if (!newApplicant) return;

    const name = newApplicant.fullName ?? "Un usuario";
    showToast(
      `${name} envió una solicitud para ser vendedor. Tenés ${pendingCount} ${
        pendingCount === 1 ? "pendiente" : "pendientes"
      }.`,
      "info",
      {
        label: "Revisar solicitud",
        onClick: () => {
          dismiss();
          navigate("/admin/vendedores");
        },
      }
    );

    dismiss();
  }, [newApplicant, pendingCount, showToast, navigate, dismiss]);

  return null;
}